import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResult } from "../shared/models/api-result";
import { IWorkArea } from "../shared/models/workarea";
import { ApiUrlProvider } from "./api-url.provider";

@Injectable({
  providedIn: "root"
})
export class WorkAreaService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IWorkArea[]>>{
    return this.http.get<IApiResult<IWorkArea[]>>(`${this.apiUrlProvider.url}/WorkArea`);
  }

  add(entity: IWorkArea): Observable<IApiResult<IWorkArea>>{
    return this.http.post<IApiResult<IWorkArea>>(`${this.apiUrlProvider.url}/WorkArea`, entity);
  }

  update(entity: IWorkArea): Observable<IApiResult<IWorkArea>>{
    return this.http.post<IApiResult<IWorkArea>>(`${this.apiUrlProvider.url}/WorkArea/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/WorkArea/${entityId}/delete`, null);
  }
}
